<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'DisciplineBalanceItem',
})

defineProps<{
  label: string
  value: number
  tooltipText?: string
}>()
</script>

<template>
  <div class="discipline-balance-item">
    <AppText
      name="body1"
      color="slate-500"
      class="discipline-balance-item__label"
    >
      {{ label }}
    </AppText>
    <div class="discipline-balance-item__content">
      <AppTooltip
        v-if="tooltipText"
        :text="tooltipText"
        placement="right"
      >
        <AppIcon
          :icon="faCircleInfo"
          size="small"
          color="slate-500"
        />
      </AppTooltip>
      <AppText name="body1">
        {{ value }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineBalanceItem.scss" />
